<template>
  <modal v-if="show">
    <template slot="header">
      <h4 class="modal-title">Kalkulator renty rodzinnej</h4>
      <a
        @click.prevent="showInfoModal(modals.familyRent)"
        href="/"
        class="info-icon"
      >
        <md-icon class="text-info">info_outline</md-icon>
        <md-tooltip md-direction="bottom">
          {{ modals.familyRent.tooltip }}
        </md-tooltip>
      </a>
      <md-button
        class="md-simple md-just-icon md-round modal-default-button"
        @click="close()"
      >
        <md-icon>clear</md-icon>
      </md-button>
    </template>
    <template slot="body">
      <div class="slider-block">
        <div class="slider-block__label">
          <p class="slider-block__name">
            Długość stażu
          </p>
          <a
            @click.prevent="showInfoModal(modals.internship)"
            href="/"
            class="info-icon"
          >
            <md-icon class="text-info">info_outline</md-icon>
            <md-tooltip md-direction="bottom">{{
              modals.internship.tooltip
            }}</md-tooltip>
          </a>
        </div>
        <Slider :step="1" :range="{ min: 1, max: 30 }" v-model="experience" />
        <div class="slider-block__display-value">
          {{ experience | year }}
        </div>
        <md-field class="select">
          <label>Podstawa składek ZUS</label>
          <md-select v-model="basisMeasure">
            <md-option v-for="val in values" :key="val" :value="val">{{
              val | percent
            }}</md-option>
          </md-select>
        </md-field>
        <div class="slider-block__sum">
          <p class="slider-block__info">
            Renta rodzinna
            <span>brutto:</span>
          </p>
          <span class="slider-block__value">
            {{ familyBrutto | currency(2) }}
          </span>
        </div>
      </div>
      <ConfiguratorModal ref="modalInfo" />
    </template>
  </modal>
</template>

<script>
import Slider from './Slider'
import Modal from './Modal'
import ConfiguratorModal from './ConfiguratorModal'
import { mapState } from 'vuex'
export default {
  name: 'optionalCalculator',
  components: { Modal, Slider, ConfiguratorModal },
  props: {},
  data() {
    return {
      values: [
        0.4,
        0.6,
        0.75,
        1,
        1.25,
        1.5,
        1.75,
        2,
        2.25,
        2.5,
        2.75,
        3,
        3.5,
        4,
        4.5,
        5,
      ],
      show: false,
      experience: 15,
      basisMeasure: 1,
      birthday: null,
      modals: {
        internship: {
          tooltip: 'Od czego zależy wysokość renty rodzinnej? ...',
          title: 'Staż pracy i wyokość podstawy ZUS',
          text: [
            'Wysokość renty rodzinnej zależy przede wszystkim od długości stażu składkowego oraz wysokości podstawy wymiaru składek ZUS. ',
            'Długość stażu - oznacz na suwaku przybliżoną liczbę lat, swojej dotychczasowej aktywności zawodowej (np etat, działalność gospodarcza)... ',
            'Podstawa składek ZUS - wybierz z listy przybliżoną średnią relację Twoich przychodów do tzw.  przeciętnego wynagrodzenia w kraju. Szczegółowe zasady ustalania tego parametru znajdziasz na stronach ZUS. Twoimi przychodami z tytułu umowy o pracę jest Twoje wynagrodzenie brutto; w przypadku działalności gospodarczej standardowo jest to 60%, przy minimalnym wynagrodzeniu w gospodarce można założyć 40%.',
          ],
        },
        familyRent: {
          tooltip: 'Czym jest renta rodzinna? ...',
          title: 'Renta rodzinna',
          text: [
            'Jeśli jesteś objęty ubezpieczeniem ZUS, masz dzieci, które nie ukończyły 25 roku życia a twój staż ubezpieczeniowy ma co najmniej 5 lat, pradopodobnie (szczegółowe kryteria znajdziesz na www.zus.pl) spełniasz kryteria do renty z tyt. całkowietej niezdolności do pracy a Twoja rodzina do otrzymania (w przypadku Twojej śmierci) renty rodzinnej. ',
            'W planowaniu ubezpieczenia na życie warto poświęcić chwilę aby zorientować się, na jaki poziom świadczenia mogłaby liczyć Twoja rodzina i jakie są kryteria jego przyznania i wypłaty. Niniejszy kalkulator przybliży Ci wysokość renty rodzinnej netto przy założonym przez Ciebie stażu pracy, podstawie wymiaru składek ZUS i założeniu 3 osób uprawnionych (np: dwójka dzieci i małżonek)',
          ],
        },
      },
    }
  },
  mounted() {
    this.setBirthday()
  },
  methods: {
    showInfoModal(data) {
      this.$refs.modalInfo.open(data)
    },
    open() {
      this.show = true
    },
    close() {
      this.show = false
      this.experience = 15
      this.basisMeasure = 1
    },
    setBirthday() {
      const selectedValue = JSON.parse(localStorage.getItem('birthday'))
        .selectedDate
      this.birthday = new Date(selectedValue.year, selectedValue.monthIndex, 1)
    },
    DifferenceInDays(firstDate, secondDate) {
      return Math.round((secondDate - firstDate) / (1000 * 60 * 60 * 24))
    },
  },
  computed: {
    ...mapState({
      maksymalnaPodstawaWymiaru: state =>
        parseFloat(state.constants.constants.Maksymalna_podstawa_wymiaru.value),
      wiekEmerytalny: state =>
        parseInt(state.constants.constants.Wiek_emerytalny.value),
      stazGwarantowany: state =>
        parseInt(state.constants.constants.Staż_gwarantowany.value),
      kwotaBazowa: state =>
        parseFloat(state.constants.constants.Kwota_bazowa.value),
      minimalmaRentaCNP: state =>
        parseFloat(state.constants.constants.Minimalna_renta_CNP.value),
      minimalnaRR: state =>
        parseInt(state.constants.constants.Minimalna_RR.value),
      wskaznikRentyRodzinnej: state =>
        parseFloat(state.constants.constants.Wskaznik_renta_rodz.value),
      stopaRentaRodz: state =>
        parseFloat(state.constants.constants.Stopa_renta_rodz.value),
    }),
    //zaliczona podstawa wymiaru
    calculatedBasisMeasure() {
      return Math.min(this.basisMeasure, this.maksymalnaPodstawaWymiaru)
    },
    //okresy składkowe
    contributoryPeriods() {
      return this.experience * 12
    },
    pensionerDate() {
      let date = new Date()
      date.setFullYear(this.birthday.getFullYear() + this.wiekEmerytalny)
      return date
    },
    monthsUntilPensioner() {
      return this.DifferenceInDays(Date.now(), this.pensionerDate) / 30
    },
    //staż hypotetyczny
    hypotheticalInternship() {
      return this.contributoryPeriods >= this.stazGwarantowany
        ? 0
        : Math.min(
            this.stazGwarantowany - this.contributoryPeriods,
            this.monthsUntilPensioner
          )
    },
    sosialPart() {
      return this.kwotaBazowa * 0.24
    },
    //okresy składkowe obliczone
    calculatedContributoryPeriods() {
      //eslint-disable-next-line
      return (
        (((this.contributoryPeriods / 12) * 1.3) / 100) *
        this.kwotaBazowa *
        this.calculatedBasisMeasure
      )
      //eslint-disable-next-line
    },
    //okres hypotetyczny
    hypotheticalTerm() {
      //eslint-disable-next-line
      return (
        (((this.hypotheticalInternship / 12) * 0.7) / 100) *
        this.kwotaBazowa *
        this.calculatedBasisMeasure
      )
      //eslint-disable-next-line
    },
    cnpBrutto() {
      return this.sosialPart +
        this.calculatedContributoryPeriods +
        this.hypotheticalTerm <
        this.minimalmaRentaCNP
        ? this.minimalmaRentaCNP
        : this.sosialPart +
            this.calculatedContributoryPeriods +
            this.hypotheticalTerm
    },
    familyBrutto() {
      return this.cnpBrutto * this.wskaznikRentyRodzinnej < this.minimalnaRR
        ? this.minimalnaRR
        : this.cnpBrutto * this.wskaznikRentyRodzinnej
    },
  },
}
</script>

<style scoped lang="scss">
.modal-title {
  margin-right: 5px;
}
.slider-block {
  max-width: 690px;
  margin: 20px auto 0;
  @media screen and (max-width: 576px) {
    /*margin-top: 10px;*/
  }
  &:first-child {
    margin-top: 50px;
    @media screen and (max-width: 576px) {
      margin-top: 10px;
    }
  }
  &__info {
    font-size: 20px;
    @media screen and (max-width: 768px) {
      font-size: 17px;
    }
    margin-bottom: 0;
  }
  &__label {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  &__name {
    font-size: 15px;
  }
  &__display-value {
    text-align: right;
    font-weight: 500;
    font-size: 18px;
    color: #3c4858;
    @media screen and (max-width: 576px) {
      font-size: 15px;
    }
  }
  &__sum {
    margin-top: 40px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    span {
      font-weight: 700;
      color: #3c4858;
      @media screen and (max-width: 576px) {
        font-size: 16px;
      }
    }
    @media screen and (max-width: 576px) {
      margin-top: 0;
    }
  }
  &__value {
    font-size: 25px;
    @media screen and (max-width: 768px) {
      font-size: 20px;
    }
    @media screen and (max-width: 576px) {
      font-size: 18px;
    }
  }
}
</style>
